// Schlanker fetch-Wrapper gegen die BeastSearch-API.
// Liest Basis-URL + API-Key aus window.beastSearchConfig.

function cfg () {
  // SSR-sicher: im Server-Bundle gibt es kein window.
  return (typeof window !== 'undefined' && window.beastSearchConfig) || {}
}

/**
 * Die anonyme Sitzungskennung — oder null, wenn der Sitzungskontext aus ist.
 *
 * Sie wird NICHT hier erzeugt, sondern kommt fertig aus der Shop-Session
 * (SessionIdProvider auf PHP-Seite). Das hat einen Grund: Die
 * Suchergebnisseite rendert Ceres serverseitig, Livesuche und Filterung laufen
 * hier im Browser. Erzeugte jede Seite ihre eigene Kennung, baute sich der
 * Kontext doppelt auf und wirkte nirgends richtig.
 *
 * Nebeneffekt, der die Loesung erst gut macht: Es braucht weder ein eigenes
 * Cookie noch sessionStorage. Die Frontend-Session von plentyONE gibt es
 * ohnehin auf jeder Seite.
 *
 * Null heisst ueberall "kein Kontext": Der Parameter entfaellt und die Suche
 * laeuft voellig normal.
 */
function sessionId () {
  const id = cfg().sessionId
  return typeof id === 'string' && id !== '' ? id : null
}

function apiUrl (endpoint) {
  const base = (cfg().apiBaseUrl || '').replace(/\/$/, '')
  return `${base}/api/shop-search/v1/${endpoint.replace(/^\//, '')}`
}

async function call (endpoint, params = {}, { method = 'GET', body = null } = {}) {
  const url = new URL(apiUrl(endpoint))
  if (method === 'GET') {
    Object.entries(params).forEach(([k, v]) => {
      if (v === undefined || v === null || v === '') return
      url.searchParams.set(k, v)
    })
  }

  const headers = { 'X-Shop-Search-Key': cfg().apiKey || '', Accept: 'application/json' }
  if (body) headers['Content-Type'] = 'application/json'

  const res = await fetch(url.toString(), {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
    credentials: 'omit'
  })
  if (!res.ok) throw new Error(`BeastSearch API ${res.status}`)
  return res.json()
}

async function callRaw (path) {
  const base = (cfg().apiBaseUrl || '').replace(/\/$/, '')
  const url = `${base}/api/shop-search/v1/${path}`
  const res = await fetch(url, {
    headers: { 'X-Shop-Search-Key': cfg().apiKey || '', Accept: 'application/json' },
    credentials: 'omit'
  })
  if (!res.ok) throw new Error(`BeastSearch API ${res.status}`)
  return res.json()
}

export const api = {
  lang: () => cfg().lang || 'de',
  /** Die Kennung dieser Sitzung (null = Sitzungskontext aus). */
  sessionId,
  suggest (q, limit) {
    const c = cfg()
    const params = { lang: this.lang(), q, limit: limit || c.suggestLimit || 10 }
    if (c.onlyInStock) params.in_stock = 1
    const sid = sessionId()
    if (sid) params.session_id = sid
    return call('suggest', params)
  },
  // Roh-Query (für verschachtelte Parameter wie attributes[Name][])
  searchRaw (queryString) {
    const sid = sessionId()
    // Anhaengen statt in ein Objekt mischen: der Aufrufer baut den
    // Query-String selbst, weil die Filter verschachtelte Namen tragen.
    const qs = sid ? queryString + '&session_id=' + encodeURIComponent(sid) : queryString
    return callRaw('search?' + qs)
  },
  /**
   * Vorschlaege fuers LEERE Suchfeld: beliebte Begriffe und meistgeklickte
   * Artikel. Der Endpunkt ist derselbe wie fuer die Wortvervollstaendigung —
   * ohne `q` liefert er die Startvorschlaege.
   */
  startSuggestions (limit) {
    const params = { lang: this.lang(), limit: limit || 6 }
    const sid = sessionId()
    if (sid) params.session_id = sid
    return call('terms', params)
  },
  /**
   * Klick aus Livesuche oder Trefferliste.
   *
   * Geht an die Plugin-Route im Shop, NICHT direkt an die BeastSearch-API:
   * Die Sitzungskennung muss aus der echten Session kommen. Kategorie- und
   * Startseiten liefert plentyONE aus dem Content-Cache - die sessionId in
   * beastSearchConfig teilen sich dort alle Besucher. Das Plugin haengt die
   * richtige Kennung serverseitig an (ConversionTracker::klick).
   *
   * keepalive: Der Klick verlaesst die Seite. Ohne das bricht der Browser die
   * Anfrage beim Seitenwechsel ab. Gleiche Domain, also kein CORS-Preflight.
   */
  trackClick (payload) {
    if (typeof window === 'undefined' || typeof fetch === 'undefined') return Promise.resolve()

    const headers = { Accept: 'application/json' }
    // Wie Ceres' eigene /rest/io-Aufrufe (ApiService.js)
    const csrf = document.getElementById('csrf-token')
    if (csrf && csrf.value) headers['X-CSRF-TOKEN'] = csrf.value

    // Formular-kodiert statt JSON: plentys Request liest Formularfelder
    // verlaesslich, JSON-Bodies nicht nachweislich.
    const body = new URLSearchParams()
    Object.entries({ lang: this.lang(), ...payload }).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== '') body.append(k, String(v))
    })

    try {
      return fetch('/rest/beastsearch/track-click', {
        method: 'POST',
        headers,
        body,
        credentials: 'same-origin',
        keepalive: true
      }).catch(() => {})
    } catch (e) {
      // Fire-and-forget
      return Promise.resolve()
    }
  }
}

export { cfg }
